import React, { useCallback, useEffect, useState } from "react";
import AdminNavigation from "../AdminNavigation";
import Select from "../../../forms/Select";
import { validateField } from "../../../pages/functions";
import { addNotification as notify } from "reapop";
import connect from "react-redux/es/connect/connect";
import { api_v2 } from "../../NewIndex.api";
import "./prod_styles.css";
import InputWithTick from "../../plugins/inputWithTickIcon";
import { REF_DATA } from "../../../constants";
import { getApplicationRegex } from "../../plugins/utils";

const AffiliateVisibility = (props) => {
  const affiliateVisibiltyFields = {
    product: {
      name: "Product",
      value: "",
      rules: { title: "Product", required: true },
    },
  };

  const [fields, setFields] = useState(affiliateVisibiltyFields);
  const [productOptions, setProductOptions] = useState([]);
  const [productList, setProductList] = useState([]);
  const [productDetails, setProductDetails] = useState([]);

  const [data, setData] = useState([]);
  const [flag, setFlag] = useState(false);

  const [urlErrors, setUrlErrors] = useState({});

  const validate = useCallback(
    (e, field) => {
      const inputValue = e.target.value.toLowerCase();
      const ref_Data = props.referenceData.find(function (category) {
        return category.type === REF_DATA;
      }).referenceData;
      const regex = getApplicationRegex(ref_Data);
  
      if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
        // Emoji detected, prevent it from being added
        showNotification(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (regex.Script_Regex !== null && regex.Script_Regex.test(inputValue)) {
        // HTML Tags and Script detected, prevent it from being added
        showNotification(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
        showNotification(
          "Error!",
          "Validation configuration is missing. Please contact support.",
          "error"
        );
        return;
      }
      const validateFields = validateField(e, field, fields);
      setFields({ ...validateFields });
    },
    [fields]
  );
  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  const getProductList = useCallback(() => {
    const products = [];
    api_v2.fetchAllProducts((JsonKeys) => {
      JsonKeys.forEach((product) => {
        products.push({
          value: product.productCode + '__' + product.name,
          label: product.name,
        });
      });
      setProductList(JsonKeys);
      setProductOptions(products);
    });
  }, []);

  useEffect(() => {
    if (productOptions.length === 0) {
      getProductList();
    }
  }, []);

  const handleProductChange = useCallback(
    (event) => {
      setUrlErrors({});
      setData([]);
      const [selectedCode, selectedName] = event.split('__');
      const selectedProduct = productList.find(
        p => p.productCode === selectedCode && p.name === selectedName
      );

      const queryParams = {
        name: selectedProduct.name,
        productCode: selectedProduct.productCode,
      };
      api_v2.getProductVisibiltyList(queryParams, (res) => {
        const masterProductDetails = [];
        //add res validations what if res is 404 soemthing like this
        res.forEach((product) => {
          masterProductDetails.push({
            affiliate: product.affiliate,
            name: product.name,
            veevaProductCode: product.veevaProductCode,
            productCode: product.productCode,
            availableToExternalUsers: product.availableToExternalUsers,
            availableToExternalForSearch: product.availableToExternalForSearch,
            patientPortalApproved: product.patientPortalApproved,
            availableForConference: product.availableForConference,
            availableForAllergen:product.availableForAllergen,
            availableForAllergenPatient:product.availableForAllergenPatient,
            piSearchLinks: product.piSearchLinks,
            availableToInternalUsers: product.availableToInternalUsers,
            availableToEmployeeForSearch: product.availableToEmployeeForSearch,
            availableForAllergenEmployee: product.availableForAllergenEmployee,
          });
        });
        setProductDetails(masterProductDetails);
        setFlag(true);
      });
    },
    [productList]
  );

  useEffect(() => {
    if (flag) {
      setData(productDetails);
    }
  }, [productDetails, flag]);

  const handleChange = (index, field, value) => {
    setData((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [field]: value } : row))
    );
    //create payload
    const updatedRow = {
      ...data[index],
      [field]: value,
    };
    //call api
    api_v2.updateProductVisibility(updatedRow, (res) =>
      UpdateVisibilityHandler(res, updatedRow)
    );
  };

  const UpdateVisibilityHandler = useCallback((res, updatedRow) => {
    if (res.status === 200) {
      showNotification(
        "Success",
        `${updatedRow.affiliate} Product updated successfully.`,
        "success"
      );
    } else if (res.status === 401) {
      showNotification(
        "Error",
        "You are not authorized to perform this action. Please log in again.",
        "error"
      );
      setTimeout(() => window.location.replace("/"), 3000);
    } else {
      showNotification(
        "Error",
        "There seems to be some error while updating product.",
        "error"
      );
    }
  }, []);

  const handleTextChange = (index, field, value) => {
    const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    const ref_Data = props.referenceData.find(function (category) {
      return category.type === REF_DATA;
    }).referenceData;
    const regex = getApplicationRegex(ref_Data);
    
    const isUrlCorrect =
      !regex.Emoji_Regex.test(value) &&
      !regex.Script_Regex.test(value) &&
      (value.trim() === "" || urlRegex.test(value) || value === "");

    setUrlErrors((prevErrors) => ({
      ...prevErrors,
      [index]: !isUrlCorrect, // true if invalid, false if valid
    }));

    if (isUrlCorrect) {
      setData((prev) =>
        prev.map((row, i) => (i === index ? { ...row, [field]: value } : row))
      );
      const updatedRow = {
        ...data[index],
        [field]: value,
      };
      api_v2.updateProductVisibility(updatedRow, (res) =>
        UpdateVisibilityHandler(res, updatedRow)
      );
    }
  };

  return (
    <div className="v2_container">
      <div className="row">
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">
                Product Visibility for Affiliates
              </h3>
              <p>Select for which users the product will be visible.</p>
              <p style={{ fontWeight: "bold", color: "grey" }}>
                If a product is disabled at country level, it will not be
                displayed for any user in that country, you can review in Edit
                Product tab.
              </p>
            </div>
          </div>
          <div className="row md-4">
            <div className="col-md-4">
              <Select
                searchable
                clearable={false}
                options={productOptions}
                field={fields.product}
                validate={(e) => validate(e, fields.product)}
                onChange={(e) => handleProductChange(e)}
              />
            </div>
          </div>
          {flag && (
            <div className="row">
              <div style={{ paddingTop: "20px", width: "100%", overflowX:"scroll" }}>
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th style={{ textAlign: "center" }}>
                        <b>Employee</b> <br />{" "}
                        <i style={{ fontWeight: "100" }}>
                          Product Visibility
                        </i>
                      </th>
                      <th style={{ textAlign: "center" }}>
                        <b>HCP </b>
                        <br />
                        <i style={{ fontWeight: "100" }}>Product Visibility</i>
                      </th>
                      <th style={{ textAlign: "center" }}>
                        <b>Patient </b>
                        <br />
                        <i style={{ fontWeight: "100" }}>Product Visibility</i>
                      </th>
                      <th style={{ textAlign: "center" }}>
                        <b>Conference & Scibooth</b>
                      </th>
                      <th style={{ textAlign: "center" }}>
                        <b>Doc Search </b>
                        <br />{" "}
                        <i style={{ fontWeight: "100" }}>Employee</i>
                      </th>
                      <th style={{ textAlign: "center" }}>
                        <b>Doc Search </b>
                        <br />{" "}
                        <i style={{ fontWeight: "100" }}>HCP</i>
                      </th>
                      <th style={{ textAlign: "center" }}>
                        <b>Allergen </b>
                        <br />
                        <i style={{ fontWeight: "100" }}>Employee</i>
                      </th>
                      <th style={{ textAlign: "center" }}>
                        <b>Allergen </b>
                        <br />
                        <i style={{ fontWeight: "100" }}>HCP</i>
                      </th>
                      <th style={{ textAlign: "center" }}>
                        <b>Allergen </b>
                        <br />
                        <i style={{ fontWeight: "100" }}>Patient</i>
                      </th>
                      <th colSpan={3} style={{ textAlign: "left" }}>
                        <b>PI Search Url</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((entry, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            fontSize: "medium",
                            fontStyle: "inherit",
                            fontWeight: "bold",
                          }}
                        >
                          {entry.affiliate}
                        </td>
                        <td>
                          <input
                            id={index}
                            title="Employee"
                            type="checkbox"
                            checked={entry.availableToInternalUsers}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "availableToInternalUsers",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            id={index}
                            title="HCP"
                            type="checkbox"
                            checked={entry.availableToExternalUsers}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "availableToExternalUsers",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            id={index}
                            title="Patient"
                            type="checkbox"
                            checked={entry.patientPortalApproved}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "patientPortalApproved",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            id={index}
                            title="Conference/Scibooth"
                            type="checkbox"
                            checked={entry.availableForConference}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "availableForConference",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            id={index}
                            title="Employee Doc Search"
                            type="checkbox"
                            checked={entry.availableToEmployeeForSearch}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "availableToEmployeeForSearch",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            id={index}
                            title="HCP Doc Search"
                            type="checkbox"
                            checked={entry.availableToExternalForSearch}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "availableToExternalForSearch",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            id={index}
                            title="Allergen Employee"
                            type="checkbox"
                            checked={entry.availableForAllergenEmployee}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "availableForAllergenEmployee",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            id={index}
                            title="Allergen HCP"
                            type="checkbox"
                            checked={entry.availableForAllergen}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "availableForAllergen",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            id={index}
                            title="Allergen"
                            type="checkbox"
                            checked={entry.availableForAllergenPatient}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "availableForAllergenPatient",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                        <td>
                          <InputWithTick
                            id={`url_${index}_${entry.name}`}
                            defaultValue={entry.piSearchLinks || ""}
                            onUpdateValue={(value) =>
                              handleTextChange(index, "piSearchLinks", value)
                            }
                          />
                          {urlErrors[index] && (
                            <div style={{ color: "red", fontSize: "small" }}>
                              Please enter a correct URL!!
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default connect(mapStateToProps, { notify })(AffiliateVisibility);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Product_Mangement/AffiliateVisibility.js